export const btnFillPillSm = 'btn btn-primary ' //
export const rowLink = 'div-td text-start text-truncate text-decoration-none text-body'
